import Cart from '~/pages/Cart';
import Collection from '~/pages/Collection';
import ContentPage from '~/templates/ContentPage';
import ErrorPage from '~/pages/ErrorPage';
import Home from '~/pages/Home';
import Product from '~/templates/Product';
import Search from '~/pages/Search';
import { LivePage } from '~/pages/LivePage';
import { InfluencerPage } from '~/pages/InfluencerPage';

const excludedRoutes = ['/account', '/checkout', '/logout'];

const routes = [
  ...excludedRoutes.map(route => {
    return {
      path: route,
      component: () => {
        window.location.href = `${window.location.origin}${route}`;
        return null;
      },
    };
  }),
  {
    path: '/live/:id?',
    component: LivePage,
  },
  {
    path: '/cart',
    component: Cart,
  },
  {
    path: '/collections/:slug',
    component: Collection,
  },
  {
    path: '/pages/:slug',
    component: ContentPage,
  },
  {
    // For deep links. https://commentsold.atlassian.net/browse/WEB-73
    path: '/products/id/:id',
    component: Product,
  },
  {
    path: '/products/:slug',
    component: Product,
  },
  {
    path: '/search',
    component: Search,
  },
  {
    path: '/store',
    component: Home,
    isHomeRoute: true,
  },
  {
    path: '/',
    component: Home,
    exact: true,
    isHomeRoute: true,
  },
  {
    path: '/:influencerSlug/:streamId?',
    component: InfluencerPage,
  },
  {
    path: '*',
    component: ErrorPage,
  },
];

export default routes;
